// src/components/Banner.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './banner.css';

const slides = [
  {
    title: "Welcome to HRD <br/> The Only Restoration Partner<br/> You'll Ever Need",
    desc: "At HRD, we pride ourselves on delivering one of the best <br/>Building Envelope Renewal / High-Rise Painting, and <br/>Restoration services across the Metro Vancouver area. <br/>We provide a minimal business disruption customer <br/>experience while keeping you fully informed and <br/>well-documented throughout your project.",
    href: "/1"
  },
  {
    title: "Welcome to HRD <br/> The Only Restoration Partner<br/> You'll Ever Need",
    desc: "At HRD, we pride ourselves on delivering one of the best <br/>Building Envelope Renewal / High-Rise Painting, and <br/>Restoration services across the Metro Vancouver area. <br/>We provide a minimal business disruption customer <br/>experience while keeping you fully informed and <br/>well-documented throughout your project.",
    href: "/2"
  },
  {
    title: "Welcome to HRD <br/> The Only Restoration Partner<br/> You'll Ever Need",
    desc: "At HRD, we pride ourselves on delivering one of the best <br/>Building Envelope Renewal / High-Rise Painting, and <br/>Restoration services across the Metro Vancouver area. <br/>We provide a minimal business disruption customer <br/>experience while keeping you fully informed and <br/>well-documented throughout your project.",
    href: "/3"
  },
  {
    title: "Welcome to HRD <br/> The Only Restoration Partner<br/> You'll Ever Need",
    desc: "At HRD, we pride ourselves on delivering one of the best <br/>Building Envelope Renewal / High-Rise Painting, and <br/>Restoration services across the Metro Vancouver area. <br/>We provide a minimal business disruption customer <br/>experience while keeping you fully informed and <br/>well-documented throughout your project.",
    href: "/4"
  }
];

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [overlayOpacity, setOverlayOpacity] = useState(1);
  const [width, setWidth] = useState(window.innerWidth);
  const [isPaused, setIsPaused] = useState(false);

  const currentPath = window.location.pathname;
  const isHome = currentPath === '/';

  // Detectar ancho para mobile/tablet/desktop
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // const isMobile = width <= 768;
  const isTablet = width > 768 && width <= 1024;

  // Cambio de slide cada 5s, pausar al hacer hover
  useEffect(() => {
    if (!isHome || isPaused) return;
    const interval = setInterval(() => {
      setCurrentSlide(i => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isHome, isPaused]);

  // Opacidad del overlay SOLO en home
  useEffect(() => {
    const onScroll = () => {
      if (!isHome) return;
      const ratio = 1 - window.scrollY / window.innerHeight;
      setOverlayOpacity(Math.max(0, Math.min(1, ratio)));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isHome]);

  // Imagen y altura según ruta y dispositivo
  const imageUrl = isHome
    ? '/assets/imgs/header/headerHome.png'
    : '/assets/imgs/header/headerHome2.png';
  const height = isHome
    ? '100vh'
    : isTablet
      ? '30vh'
      : '40vh';

  return (
    <div
      className="banner-new"
      style={{
        backgroundImage: `url(${imageUrl})`,
        height
      }}
    >
      {isHome && (
        <>
          <div
            className="overlay"
            style={{
              backgroundImage: `url('../../../assets/imgs/header/headerPolygon.jpg')`,
              opacity: overlayOpacity
            }}
          />
          <div
            className="floating-slider"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            {slides.map((slide, idx) => (
              <div
                key={idx}
                className={`slide ${currentSlide === idx ? 'active' : ''}`}
              >
                <h1 dangerouslySetInnerHTML={{ __html: slide.title }} />
                <p className='casper-normal' dangerouslySetInnerHTML={{ __html: slide.desc }} />
                <Link to={slide.href} className="slider-btn-header btn-general">
                  LEARN MORE
                </Link>
              </div>
            ))}
            <div className="slider-dots">
              {slides.map((_, idx) => (
                <button
                  key={idx}
                  className={`dot ${currentSlide === idx ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(idx)}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Banner;
